






















































import Vue from 'vue';
import { Component, PropSync } from 'vue-property-decorator';

@Component({})
export default class MapTab extends Vue {
	@PropSync('colors') public colorsProp: {
		worldColors: {
			percentiles: string,
			nodata: string,
			default: string,
			hover: string,
			clicked: string,
			border: string,
		},
		russiaColors: {
			nodata: string,
			default: string,
			hover: string,
			clicked: string,
			border: string,
		},
	};
	public color = '#000000FF';
}
